import INFTCollections from '../models/INFTCollections'

//default
import DefaultCard from '../nftFormats/Default/Card/DefaultCard'
import DefaultDetail from '../nftFormats/Default/Detail/DefaultlDetail'
import ActivityDetail from '../nftFormats/Default/Activity/ActivityDetail'

import { YetiSwapData, YetiSwapCategoryData } from './NFTCollections/YetiSwapData'

import { AvalancheFriendsData, AvalancheFriendsCategoryData } from './NFTCollections/AvalancheFriendsData'
import { AvawareAllenData, AvawareAllenCategoryData } from './NFTCollections/AvawareAllenData'
import { AVAXBrosNFTData, AVAXBrosNFTCategoryData } from './NFTCollections/AVAXBrosNFTData'
import { AvaxcellsData, AvaxcellsCategoryData } from './NFTCollections/AvaxcellsData'
import { AvaxtarsData, AvaxtarsCategoryData } from './NFTCollections/AvaxtarsData'
import { CryptoDappersData, CryptoDappersCategoryData } from './NFTCollections/CryptoDappersData'
import { CryptosealData, CryptosealCategoryData } from './NFTCollections/CryptosealData'
import { CryptoWaifusData, CryptoWaifusCategoryData } from './NFTCollections/CryptoWaifusData'
import { HatchyPocketsData, HatchyPocketsCategoryData } from './NFTCollections/HatchyPocketsData'
import { HeroesOfNFTDataData, HeroesOfNFTCategoryData } from './NFTCollections/HeroesOfNFTData'
import { NovaXData, NovaXCategoryData } from './NFTCollections/NovaxData'
import { SnowBallData, SnowBallCategoryData } from './NFTCollections/SnowBallData'
import { SporeData, SporeCategoryData } from './NFTCollections/SporeData'
import { ChillAFSlothsData, ChillAFSlothsCategoryData } from './NFTCollections/ChillAFSlothsData'
import { HuskyNFTCategoryData, HuskyNFTData } from './NFTCollections/HuskNFTData'
import { AvaxCatsCategoryData, AvaxCatsData } from './NFTCollections/AvaxCatsData'
import { LootFishCategoryData, LootFishData } from './NFTCollections/LootFishData'
import { AvaxPudgyPenguinsCategoryData, AvaxPudgyPenguinsData } from './NFTCollections/PudgyPenguins'
import { DeproApeCryptoClubCategoryData, DeproApeCryptoClubData } from './NFTCollections/DeproApeCryptoClubData'
import { NeonMonstersCategoryData, NeonMonstersData } from './NFTCollections/NeonMonstersData'
import { TubbyReindeerCategoryData, TubbyReindeerData } from './NFTCollections/TubbyReindeerData'
import { AvaPepeCategoryData, AvaPepeData } from './NFTCollections/AvaPepesData'
import { TinyDragonCategoryData, TinyDragonData } from './NFTCollections/TinyDragonData'
import { AngryBearsCategoryData, AngryBearsData } from './NFTCollections/AngryBearsData'
import { NftSoccerGamesCategoryData, NftSoccerGamesData } from './NFTCollections/NftSoccerGamesData'

const CollectionList: INFTCollections[] = [
  {
    id: 'yetiswapCollection',
    tokenAddress: '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d',
    name: 'YetiSwap Collection',
    cardFormat: DefaultCard,
    detailFormat: DefaultDetail,
    activityFormat: ActivityDetail,
    category: 0,
    creatorAddress: ''
  },
  ...YetiSwapData,
  ...AvalancheFriendsData,
  ...AvawareAllenData,
  ...AVAXBrosNFTData,
  ...AvaxCatsData,
  AvaxcellsData,
  ...AvaxtarsData,
  CryptoDappersData,
  ...CryptosealData,
  CryptoWaifusData,
  ...DeproApeCryptoClubData,
  HatchyPocketsData,
  HeroesOfNFTDataData,
  ...HuskyNFTData,
  ...LootFishData,
  ...NeonMonstersData,
  ...NovaXData,
  ...AvaxPudgyPenguinsData,
  ...SnowBallData,
  ...SporeData,
  ChillAFSlothsData,
  ...TubbyReindeerData,
  ...AvaPepeData,
  ...TinyDragonData,
  ...AngryBearsData,
 // ...HistoryMintedData,
  ...NftSoccerGamesData,
]

export const CollectionObjectList: { [key: string]: number } = {
  ...AvalancheFriendsCategoryData,
  ...AvawareAllenCategoryData,
  ...AVAXBrosNFTCategoryData,
  ...AvaxCatsCategoryData,
  ...AvaxcellsCategoryData,
  ...AvaxtarsCategoryData,
  ...CryptoDappersCategoryData,
  ...CryptosealCategoryData,
  ...CryptoWaifusCategoryData,
  ...DeproApeCryptoClubCategoryData,
  ...HatchyPocketsCategoryData,
  ...HeroesOfNFTCategoryData,
  ...HuskyNFTCategoryData,
  ...LootFishCategoryData,
  ...NeonMonstersCategoryData,
  ...NovaXCategoryData,
  ...AvaxPudgyPenguinsCategoryData,
  ...SnowBallCategoryData,
  ...SporeCategoryData,
  ...YetiSwapCategoryData,
  ...ChillAFSlothsCategoryData,
  ...TubbyReindeerCategoryData,
  ...AvaPepeCategoryData,
  ...TinyDragonCategoryData,
  ...AngryBearsCategoryData,
  ...NftSoccerGamesCategoryData
}

export default CollectionList
